import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';


@Injectable({
  providedIn: 'root'
})
export class MobileVehiclesService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get vehicles by location
   * @returns Array
   */
  getVehiclesByLocation(locationId:string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/filter-vehicles-by-location/${locationId}/dynamic`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get vehicles by branch
   * @returns Array
   */
  getVehiclesByBranch(branchId:string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/filter-vehicles-by-branch/${branchId}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get vehicles by location type
   * @returns Array
   */
  getVehiclesByLocationType(locationId:string, locationType:string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/filter-vehicles-by-location/${locationId}/${locationType}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get single vehicle record
   * @param vehicle_id
   */
  getVehicle(vehicle_id: string){

    let apiURL:string=`${this.baseURL}/v1/get-vehicle-details/${vehicle_id}/mobile`;

    return this.http.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get vehicle photos
   * @param vehicle_id
   * @returns Observable<ApiResponse>
   */
  fetchVehiclePhotos(vehicle_id: string|null): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-vehicle-photos/${vehicle_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get vehicle status
   * @param vehicle_id
   */
  getVehicleStatus(vehicle_id: string)
  {

    let apiURL:string=`${this.baseURL}/v1/get-vehicle-status/${vehicle_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get recently transferred vehicles
   * @returns Array
   */
  getRecentlyTransferredVehicles(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/recently-transferred-vehicles`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get incoming transfers
   * @returns Array
   */
  getIncomingTransfers(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/get-incoming-transfers`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
